<template>
  <Toast
    group="file-submission-upload"
    position="bottom-left"
    style="z-index: 1007"
  >
    <!--
      closeCallback is a closure PrimeVue creates per message instance. Calling
      it emits a 'close' event carrying that message's unique id, so Toast.vue
      splices only that entry out of its messages array — other toasts are
      unaffected. Each batch therefore closes itself independently.
    -->
    <template #container="{ message, closeCallback }">
      <AppToastNotificationFileSubmissionUploadBatch
        :batch-id="String(message.data?.batchId ?? '')"
        :close-callback="closeCallback"
      />
    </template>
  </Toast>
</template>

<script setup lang="ts">
import Toast from 'primevue/toast'
</script>
